import { useEffect, useState } from 'react'
import Button from '@/components/ui/Button'
import { assignPair, getTrainerPairs, removePair, TrainingPair } from '@/services/pairs'

interface Member { id: string; user: { first_name: string; last_name?: string } }
export default function TrainerPairsPanel({clients}:{clients:Member[]}) {
  const [pairs,setPairs]=useState<TrainingPair[]>([])
  const [open,setOpen]=useState(false)
  const [a,setA]=useState('')
  const [b,setB]=useState('')
  const [busy,setBusy]=useState(false)
  const [error,setError]=useState('')
  const load=async()=>setPairs(await getTrainerPairs())
  useEffect(()=>{void load().catch(()=>setError('Не удалось загрузить пары'))},[])
  const used=new Set(pairs.flatMap(p=>p.members?.map(m=>m.id)??[]))
  const options=clients.filter(c=>!used.has(c.id))
  const mutate=async(action:()=>Promise<unknown>)=>{
    if(busy)return
    setBusy(true);setError('')
    try {await action();await load();setA('');setB('')}
    catch(e:any){setError(e.response?.data?.detail||'Не удалось сохранить пару')}
    finally{setBusy(false)}
  }
  return <section className="mb-5 rounded-xl bg-tg-secondary p-4">
    <button type="button" className="min-h-11 w-full text-left font-semibold" aria-expanded={open} onClick={()=>setOpen(!open)}>Парные тренировки ({pairs.length})</button>
    {open&&<div className="space-y-3">
      <p className="text-sm text-tg-hint">Назначьте постоянную пару. Оба смогут предлагать время, второй подтверждает участие. Они записываются только вместе и занимают два места в слоте</p>
      {error&&<p role="alert" className="text-sm text-red-600">{error}</p>}
      {pairs.map(p=><div key={p.id} className="rounded-lg bg-tg-bg p-3">
        <p className="font-medium">{p.members?.map(m=>m.name).join(' и ')}</p>
        <button type="button" disabled={busy} className="min-h-11 text-sm text-red-600" onClick={()=>{
          if(confirm('Расформировать пару? Все будущие парные тренировки и ожидающие предложения отменятся. Оба участника получат уведомления.'))void mutate(()=>removePair(p.id))
        }}>Расформировать пару</button>
      </div>)}
      <label className="block text-sm">Первый участник
        <select aria-label="Первый участник пары" value={a} onChange={e=>setA(e.target.value)} disabled={busy} className="mt-1 w-full rounded-lg border p-3 bg-tg-bg text-tg-text">
          <option value="" disabled hidden>Выберите подопечного</option>{options.filter(c=>c.id!==b).map(c=><option key={c.id} value={c.id}>{c.user.first_name} {c.user.last_name}</option>)}
        </select>
      </label>
      <label className="block text-sm">Второй участник
        <select aria-label="Второй участник пары" value={b} onChange={e=>setB(e.target.value)} disabled={busy} className="mt-1 w-full rounded-lg border p-3 bg-tg-bg text-tg-text">
          <option value="" disabled hidden>Выберите подопечного</option>{options.filter(c=>c.id!==a).map(c=><option key={c.id} value={c.id}>{c.user.first_name} {c.user.last_name}</option>)}
        </select>
      </label>
      <Button fullWidth loading={busy} disabled={!a||!b||a===b} onClick={()=>void mutate(()=>assignPair(a,b))}>Объединить в пару</Button>
    </div>}
  </section>
}
